import React from "react";

const NearbySkeleton = ({ count = 4 }) => (
  <div className="nearby-results">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="nearby-skeleton-card" aria-hidden>
        <div className="nearby-skeleton-line nearby-skeleton-line--lg" />
        <div className="nearby-skeleton-line nearby-skeleton-line--sm" />
        <div className="nearby-skeleton-line nearby-skeleton-line--md" />
        <div className="nearby-skeleton-actions">
          <div className="nearby-skeleton-line nearby-skeleton-line--btn" />
          <div className="nearby-skeleton-line nearby-skeleton-line--btn" />
        </div>
      </div>
    ))}
  </div>
);

export default NearbySkeleton;
